/** Быстрые возвраты не перечитывают всю таблицу. Изменения и права сбрасывают срок. */
export const TABLE_FRESH_MS = 10_000;

export function createTableFreshness() {
  let generation = 0;
  let freshUntil = 0;
  function invalidate() {
    freshUntil = 0;
    return ++generation;
  }
  return {
    invalidate,
    beginRead: invalidate,
    isFresh: () => Date.now() < freshUntil,
    markFresh(read: number) {
      // Событие, пришедшее во время GET, новее его снимка.
      if (read === generation) freshUntil = Date.now() + TABLE_FRESH_MS;
    },
  };
}
